import { useAuth } from '@/contexts/AuthContext';

// خريطة الصلاحيات المحسنة مرتبطة بأسماء الصلاحيات في قاعدة البيانات - محدثة شاملة
const MENU_PERMISSIONS_MAP = {
  // الصفحة الرئيسية
  '/': {
    permission: 'الرئيسية',
    category: 'dashboard'
  },
  '/dashboard': {
    permission: 'الرئيسية',
    category: 'dashboard'
  },
  
  // إدارة العملاء - محدثة
  '/clients': {
    permission: 'العملاء',
    category: 'clients'
  },
  '/clients-management': {
    permission: 'إدارة العملاء',
    category: 'clients'
  },
  '/clients/add': {
    permission: 'إضافة عميل',
    category: 'clients'
  },
  '/clients/direct': {
    permission: 'العملاء المباشرين',
    category: 'clients'
  },
  '/clients/corporate': {
    permission: 'العملاء المؤسسيين',
    category: 'clients'
  },
  '/clients/b2b': {
    permission: 'عملاء B2B',
    category: 'clients'
  },
  '/client-follow-up': {
    permission: 'متابعة العملاء',
    category: 'clients'
  },
  '/client-status': {
    permission: 'حالات العملاء',
    category: 'clients'
  },
  '/client-status-management': {
    permission: 'إدارة حالات العملاء',
    category: 'clients'
  },
  '/companies': {
    permission: 'الشركات',
    category: 'clients'
  },
  '/company-management': {
    permission: 'إدارة الشركات',
    category: 'clients'
  },
  '/chatwoot-clients': {
    permission: 'عملاء Chatwoot',
    category: 'clients'
  },
  
  // البرامج السياحية - محدثة
  '/create-package': {
    permission: 'إنشاء الباقات',
    category: 'tourism'
  },
  '/tourism-packages': {
    permission: 'الباقات السياحية',
    category: 'tourism'
  },
  '/package-search': {
    permission: 'البحث عن الباقات',
    category: 'tourism'
  },
  '/package-results': {
    permission: 'نتائج البحث',
    category: 'tourism'
  },
  '/package-inclusions': {
    permission: 'شمول الباقات',
    category: 'tourism'
  },
  '/package-exclusions': {
    permission: 'استثناءات الباقات',
    category: 'tourism'
  },
  
  // إدارة البرامج السياحية - محدثة بالكامل
  '/airlines': {
    permission: 'شركات الطيران',
    category: 'tourism_management'
  },
  '/airports': {
    permission: 'المطارات',
    category: 'tourism_management'
  },
  '/flights': {
    permission: 'الرحلات الجوية',
    category: 'tourism_management'
  },
  '/hotels': {
    permission: 'الفنادق',
    category: 'tourism_management'
  },
  '/countries': {
    permission: 'الدول',
    category: 'tourism_management'
  },
  '/cities': {
    permission: 'المدن',
    category: 'tourism_management'
  },
  '/services': {
    permission: 'الخدمات',
    category: 'tourism_management'
  },
  '/service-country-mapping': {
    permission: 'ربط الخدمات بالدول',
    category: 'tourism_management'
  },
  '/vehicle-types': {
    permission: 'المواصلات',
    category: 'tourism_management'
  },
  '/airport-transfers': {
    permission: 'نقل المطارات',
    category: 'tourism_management'
  },
  '/country-vehicle-mapping': {
    permission: 'ربط المواصلات بالدول',
    category: 'tourism_management'
  },
  '/tourist-tours': {
    permission: 'الجولات السياحية',
    category: 'tourism_management'
  },
  '/customer-reception-boards': {
    permission: 'لوحات استقبال العلماء',
    category: 'tourism_management'
  },
  '/shipping-companies': {
    permission: 'شركات النقل البحري',
    category: 'tourism_management'
  },
  '/ports': {
    permission: 'الموانئ',
    category: 'tourism_management'
  },
  '/cruise-trips': {
    permission: 'الرحلات البحرية',
    category: 'tourism_management'
  },
  
  // الموارد البشرية - محدثة
  '/employees': {
    permission: 'الموظفين',
    category: 'hr'
  },
  '/employee-profile': {
    permission: 'الملف الشخصي',
    category: 'hr'
  },
  '/employee-analytics': {
    permission: 'تحليلات الموظفين',
    category: 'hr'
  },
  '/employee-dashboard': {
    permission: 'لوحة تحكم الموظف',
    category: 'hr'
  },
  '/attendance': {
    permission: 'الحضور',
    category: 'hr'
  },
  
  // الموردين - محدثة
  '/suppliers': {
    permission: 'الموردون',
    category: 'suppliers'
  },
  '/drivers': {
    permission: 'السائقين',
    category: 'suppliers'
  },
  
  // التأشيرات - محدثة
  '/visas': {
    permission: 'التأشيرات',
    category: 'visas'
  },
  '/visa-types': {
    permission: 'أنواع التأشيرات',
    category: 'visas'
  },
  
  // المهام
  '/tasks': {
    permission: 'المهام',
    category: 'tasks'
  },
  
  // أدوات العمل - محدثة
  '/messages': {
    permission: 'الرسائل',
    category: 'tools'
  },
  '/email-system': {
    permission: 'نظام الإيميل',
    category: 'tools'
  },
  '/notifications': {
    permission: 'الإشعارات',
    category: 'tools'
  },
  '/session-logs': {
    permission: 'سجل الجلسات',
    category: 'tools'
  },
  '/activity-logs': {
    permission: 'سجل النشاطات',
    category: 'tools'
  },
  '/employee-login-map': {
    permission: 'خريطة تسجيل الموظفين',
    category: 'tools'
  },
  '/teletel': {
    permission: 'نظام Teletel',
    category: 'tools'
  },
  
  // الإدارة والصلاحيات - محدثة
  '/permissions': {
    permission: 'إدارة الصلاحيات',
    category: 'admin'
  },
  '/system-health': {
    permission: 'فحص صحة النظام',
    category: 'admin'
  },
  '/system-monitoring': {
    permission: 'مراقبة النظام',
    category: 'admin'
  },
  '/monitoring/sentry': {
    permission: 'مراقبة Sentry',
    category: 'admin'
  },
  '/monitoring/logrocket': {
    permission: 'مراقبة LogRocket',
    category: 'admin'
  },
  '/monitoring/mixpanel': {
    permission: 'مراقبة Mixpanel',
    category: 'admin'
  },
  '/monitoring/jest': {
    permission: 'اختبار Jest',
    category: 'admin'
  },
  '/monitoring/newrelic': {
    permission: 'مراقبة New Relic',
    category: 'admin'
  },
  '/monitoring/datadog': {
    permission: 'مراقبة DataDog',
    category: 'admin'
  },
  '/monitoring/cypress': {
    permission: 'اختبار Cypress',
    category: 'admin'
  },
  '/monitoring/storybook': {
    permission: 'مراقبة Storybook',
    category: 'admin'
  },
  '/monitoring/lighthouse': {
    permission: 'مراقبة Lighthouse',
    category: 'admin'
  },
  
  // التحليلات - محدثة
  '/ai-analytics': {
    permission: 'تحليلات الذكاء الاصطناعي',
    category: 'analytics'
  },
  '/smart-performance': {
    permission: 'مراقبة الأداء الذكية',
    category: 'analytics'
  },
  
  // المالية
  '/currencies': {
    permission: 'العملات',
    category: 'finance'
  },
  
  // الإعدادات
  '/settings': {
    permission: 'الإعدادات',
    category: 'settings'
  },
  '/pdf-template-settings': {
    permission: 'إعدادات نماذج PDF',
    category: 'settings'
  }
};

// الصلاحيات المتاحة في النظام - محدثة شاملة لتتطابق مع جميع الأقسام
const ALL_SYSTEM_PERMISSIONS = [
  // الصلاحيات الأساسية
  'الرئيسية',
  'الإعدادات',
  'إعدادات نماذج PDF',
  'الإشعارات',
  'الرسائل',
  'نظام الإيميل',
  'الملف الشخصي',
  
  // إدارة العملاء - محدثة شاملة
  'العملاء',
  'إدارة العملاء',
  'عرض العملاء',
  'إضافة عميل',
  'تعديل العملاء',
  'حذف العملاء',
  'العملاء المباشرين',
  'العملاء المؤسسيين',
  'عملاء B2B',
  'متابعة العملاء', 
  'حالات العملاء',
  'إدارة حالات العملاء',
  'الشركات',
  'إدارة الشركات',
  'عملاء Chatwoot',
  
  // الموارد البشرية - محدثة
  'الموظفين',
  'تحليلات الموظفين',
  'الحضور',
  'لوحة تحكم الموظف',
  
  // البرامج السياحية - محدثة شاملة
  'إنشاء الباقات',
  'الباقات السياحية',
  'البحث عن الباقات',
  'نتائج البحث',
  'شمول الباقات',
  'استثناءات الباقات',
  
  // إدارة البرامج - محدثة شاملة
  'شركات الطيران',
  'المطارات',
  'الرحلات الجوية',
  'الفنادق',
  'الدول',
  'المدن',
  'الخدمات',
  'ربط الخدمات بالدول',
  'المواصلات',
  'نقل المطارات',
  'ربط المواصلات بالدول',
  'الجولات السياحية',
  'لوحات استقبال العلماء',
  'شركات النقل البحري',
  'الموانئ',
  'الرحلات البحرية',
  
  // الموردين - محدثة
  'الموردون',
  'السائقين',
  
  // التأشيرات - محدثة
  'التأشيرات',
  'أنواع التأشيرات',
  
  // المهام
  'المهام',
  
  // أدوات العمل - محدثة
  'سجل الجلسات',
  'سجل النشاطات',
  'خريطة تسجيل الموظفين',
  'نظام Teletel',
  
  // الإدارة والصلاحيات - محدثة شاملة
  'إدارة الصلاحيات',
  'فحص صحة النظام',
  'مراقبة النظام',
  'إدارة التكامل',
  'مراقبة Sentry',
  'مراقبة LogRocket',
  'مراقبة Mixpanel',
  'اختبار Jest',
  'مراقبة New Relic',
  'مراقبة DataDog',
  'اختبار Cypress',
  'مراقبة Storybook',
  'مراقبة Lighthouse',
  
  // التحليلات - محدثة
  'تحليلات الذكاء الاصطناعي',
  'مراقبة الأداء الذكية',
  
  // المالية
  'العملات',
  
  // أخرى - للتوافق مع النظام القديم
  'البيانات',
  'العروض',
  'داشبورد'
];

// الصلاحيات حسب الفئة - محدثة شاملة لتتطابق مع النظام الجديد
const CATEGORY_PERMISSIONS = {
  dashboard: ['الرئيسية', 'داشبورد'],
  
  clients: [
    'العملاء', 'إدارة العملاء', 'عرض العملاء', 'إضافة عميل', 'تعديل العملاء', 'حذف العملاء',
    'العملاء المباشرين', 'العملاء المؤسسيين', 'عملاء B2B',
    'متابعة العملاء', 'حالات العملاء', 'إدارة حالات العملاء',
    'الشركات', 'إدارة الشركات', 'عملاء Chatwoot'
  ],
  
  tourism: [
    'إنشاء الباقات', 'الباقات السياحية', 'البحث عن الباقات', 'نتائج البحث',
    'شمول الباقات', 'استثناءات الباقات'
  ],
  
  tourism_management: [
    'شركات الطيران', 'المطارات', 'الرحلات الجوية',
    'الفنادق', 'الدول', 'المدن',
    'الخدمات', 'ربط الخدمات بالدول',
    'المواصلات', 'نقل المطارات', 'ربط المواصلات بالدول',
    'الجولات السياحية', 'لوحات استقبال العلماء',
    'شركات النقل البحري', 'الموانئ', 'الرحلات البحرية'
  ],
  
  hr: [
    'الموظفين', 'تحليلات الموظفين', 'الحضور', 
    'الملف الشخصي', 'لوحة تحكم الموظف'
  ],
  
  suppliers: ['الموردون', 'السائقين'],
  
  visas: ['التأشيرات', 'أنواع التأشيرات'],
  
  tasks: ['المهام'],
  
  tools: [
    'الرسائل', 'نظام الإيميل', 'الإشعارات',
    'سجل الجلسات', 'سجل النشاطات', 'خريطة تسجيل الموظفين',
    'نظام Teletel'
  ],
  
  admin: [
    'إدارة الصلاحيات', 'فحص صحة النظام', 'مراقبة النظام', 'إدارة التكامل',
    'مراقبة Sentry', 'مراقبة LogRocket', 'مراقبة Mixpanel',
    'اختبار Jest', 'مراقبة New Relic', 'مراقبة DataDog',
    'اختبار Cypress', 'مراقبة Storybook', 'مراقبة Lighthouse'
  ],
  
  analytics: [
    'تحليلات الذكاء الاصطناعي', 'مراقبة الأداء الذكية'
  ],
  
  finance: ['العملات'],
  
  settings: ['الإعدادات', 'إعدادات نماذج PDF'],
  
  other: ['البيانات', 'العروض']
};

export function useEnhancedPermissions() {
  const { user } = useAuth();

  const hasPermission = (permission: string): boolean => {
    if (!user) return false;
    
    // قائمة الإيميلات للمدراء الرئيسيين
    const adminEmails = ['klidmorre@gmail.com', 'eng.khalid.work@gmail.com'];
    const adminPositions = ['مدير النظام', 'مدير عام', 'مدير النظام الرئيسي', 'مدير النظام العام'];
    
    // التحقق من الإيميل أولاً - له الأولوية القصوى
    if (user.employeeData?.email && adminEmails.includes(user.employeeData.email)) {
      console.log(`System admin email detected: ${user.employeeData.email}, granting ALL permissions`);
      return true;
    }
    
    // التحقق من المنصب
    if (user.employeeData?.position && adminPositions.includes(user.employeeData.position)) {
      console.log(`Admin position detected: ${user.employeeData.position}, granting permission`);
      return true;
    }
    
    // التحقق من الأسماء والأدوار الخاصة
    if (user.username === 'مدير النظام العام' || user.role === 'مدير النظام العام') {
      console.log('System admin role detected, granting permission');
      return true;
    }
    
    // التحقق من صلاحيات ALL
    if (user.permissions === 'ALL') {
      console.log('ALL permissions granted for:', permission);
      return true;
    }
    if (Array.isArray(user.permissions) && user.permissions.includes('ALL')) {
      console.log('ALL permissions (array) granted for:', permission);
      return true;
    }
    
    // التحقق من حالة الموافقة للمستخدمين العاديين فقط
    // المدراء معفيون من هذا الشرط
    if (user.employeeData?.approval_status !== 'approved') {
      // إعفاء المدراء من شرط الموافقة
      if (user.employeeData?.email && adminEmails.includes(user.employeeData.email)) {
        return true;
      }
      // الموظفون غير المعتمدون يمكنهم الوصول فقط للملف الشخصي
      return permission === 'الملف الشخصي';
    }
    
    // التحقق من الصلاحيات العادية
    if (Array.isArray(user.permissions)) {
      return user.permissions.includes(permission);
    }
    
    return false;
  };

  const canAccessRoute = (route: string): boolean => {
    // السماح بالوصول لصفحة تسجيل الدخول دائماً
    if (route === '/login') return true;
    
    // التحقق من وجود مستخدم مسجل
    if (!user) return false;
    
    // مدير النظام الرئيسي له صلاحيات كاملة
    if (user.employeeData?.email === 'klidmorre@gmail.com') {
      return true;
    }
    
    // مدير النظام يمكنه الوصول لجميع الصفحات
    if (user.permissions === 'ALL') return true;
    if (Array.isArray(user.permissions) && user.permissions.includes('ALL')) return true;
    
    // السماح بالوصول للصفحة الرئيسية لجميع المستخدمين المسجلين والمعتمدين
    if (route === '/' || route === '/dashboard') {
      return user.employeeData?.approval_status === 'approved' || user.employeeData?.email === 'klidmorre@gmail.com';
    }
    
    // التحقق من حالة الموافقة للصفحات الأخرى
    if (user.employeeData?.approval_status !== 'approved') {
      // الموظفون غير المعتمدون يمكنهم الوصول فقط لصفحة الملف الشخصي
      return route === '/employee-profile';
    }

    // التحقق من الصلاحية المطلوبة للمسار
    const routePermission = MENU_PERMISSIONS_MAP[route as keyof typeof MENU_PERMISSIONS_MAP];
    if (routePermission) {
      return hasPermission(routePermission.permission);
    }

    // إذا لم يوجد مسار محدد في الخريطة، السماح بالوصول للمستخدمين المعتمدين
    return true;
  };

  const getCategoryPermissions = (category: keyof typeof CATEGORY_PERMISSIONS) => {
    return CATEGORY_PERMISSIONS[category] || [];
  };

  const getAllAvailablePermissions = () => {
    return ALL_SYSTEM_PERMISSIONS;
  };

  const getPermissionsByCategory = () => {
    return CATEGORY_PERMISSIONS;
  };

  const getUserPermissionsByCategory = () => {
    if (!user?.permissions) return {};
    
    if (user.permissions === 'ALL' || user.username === 'مدير النظام الرئيسي') {
      return CATEGORY_PERMISSIONS;
    }

    const userCategoryPermissions: Record<string, string[]> = {};
    
    Object.entries(CATEGORY_PERMISSIONS).forEach(([category, permissions]) => {
      const userPermissionsInCategory = permissions.filter(permission => 
        Array.isArray(user.permissions) && user.permissions.includes(permission)
      );
      
      if (userPermissionsInCategory.length > 0) {
        userCategoryPermissions[category] = userPermissionsInCategory;
      }
    });

    return userCategoryPermissions;
  };

  const getFilteredMenuItems = () => {
    // سيتم تنفيذ هذا في الكومبوننت المناسب
    return [];
  };

  return {
    hasPermission,
    canAccessRoute,
    getCategoryPermissions,
    getAllAvailablePermissions,
    getPermissionsByCategory,
    getUserPermissionsByCategory,
    getFilteredMenuItems,
    userPermissions: user?.permissions || [],
    isSystemAdmin: user?.permissions === 'ALL' || user?.username === 'مدير النظام الرئيسي',
    MENU_PERMISSIONS_MAP,
    CATEGORY_PERMISSIONS
  };
}